export default "__VITE_ASSET__BwD1nXeG__"